export const SDK_VERSION = '7.46.0';
